import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Avatar, DisplayText } from '@superops/ui-design-system';
import { SVGIconWithColorBg } from '@nile/components';
import { getTranslatedText } from '@nile/components/src/Utils/helpers';
import { useIntl } from 'react-intl';

const GroupHeaderCell = (props) => {
  const {
    svgIconType,
    labelText,
    textcolor,
    bgColor,
    iconColor,
    iconName,
    subLabel
  } = props;
  const SVG =
    svgIconType === 'withColorBg'
      ? SVGIconWithColorBg
      : svgIconType === 'default'
      ? SVGIcon
      : null;
  const intl = useIntl();

  return (
    <div className="fx center g10" style={{ color: textcolor }}>
      {SVG ? (
        <SVG name={iconName} color={iconColor} bgColor={bgColor} />
      ) : (
        <Avatar
          initials={labelText.slice(0, 1).toUpperCase()}
          size="extraSmall"
        />
      )}
      <DisplayText size="extraLarge" weight="Bold">
        {getTranslatedText(intl, labelText)}
        {subLabel ? ` - ${subLabel}` : ''}
      </DisplayText>
    </div>
  );
};

export default GroupHeaderCell;
